import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMicrophone = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 0c-3.313 0-6 2.688-6 6v10c0 3.313 2.688 6 6 6 3.313 0 6-2.688 6-6V6c0-3.313-2.688-6-6-6ZM8 13.5c0-.831-.669-1.5-1.5-1.5S5 12.669 5 13.5V16c0 5.569 4.137 10.169 9.5 10.9V29h-3c-.831 0-1.5.669-1.5 1.5s.669 1.5 1.5 1.5h9c.831 0 1.5-.669 1.5-1.5s-.669-1.5-1.5-1.5h-3v-2.1c5.363-.731 9.5-5.331 9.5-10.9v-2.5c0-.831-.669-1.5-1.5-1.5s-1.5.669-1.5 1.5V16a8 8 0 0 1-8 8 8 8 0 0 1-8-8v-2.5Z",
		fill: "currentColor"
	})
});
export default SvgIconMicrophone;
